// extracted by mini-css-extract-plugin
export default {"construccionContainer":"ContactarAlfredo_construccionContainer__YPW1o","cartelMedio":"ContactarAlfredo_cartelMedio__1nTsh","logo":"ContactarAlfredo_logo__--2SQ"};